<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            name="from"
            v-model="email.from"
            placeholder="De (E-mail)"
            data-vv-as="De"
            v-validate="'required|email|max:255'"
            :error="validationErrors.first('from')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            name="to"
            v-model="email.to"
            placeholder="Para (E-mail(s) - separe por vírgula)"
            data-vv-as="Para"
            v-validate="'required|max:1000'"
            :error="validationErrors.first('to')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="textarea"
            name="body"
            v-model="email.body"
            placeholder='Corpo do E-mail (HTML ou texto)'
            data-vv-as="Corpo"
            v-validate="'required'"
            :error="validationErrors.first('body')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent
            name="enfileirado"
            v-model="email.enfileirado"
            :listaDeOptions="statusEnfileirado"
            :optionLabel="'nome'"
            :optionValue="'valor'"
            placeholder="Status de Enfileiramento"
            data-vv-as="Enfileirado"
            v-validate="'required'"
            :error="validationErrors.first('enfileirado')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioPcoEmailsQueueComponent',

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    emailSelecionado: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data () {
    return {
      email: {
        id: this.emailSelecionado.id || null,
        from: this.emailSelecionado.from || '',
        to: this.emailSelecionado.to || '',
        body: this.emailSelecionado.body || '',
        enfileirado: this.emailSelecionado.enfileirado !== undefined ? this.emailSelecionado.enfileirado : false
      },
      statusEnfileirado: [
        { nome: 'Pendente', valor: false },
        { nome: 'Enfileirado', valor: true }
      ]
    }
  },

  methods: {
    ...mapActions('pcoEmailsQueue', [
      'salvarEmail',
      'atualizarEmail'
    ]),

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      try {
        const formData = { ...this.email }

        const emails = formData.to.split(',').map(e => e.trim())
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        for (const emailAddr of emails) {
          if (!emailRegex.test(emailAddr)) {
            this.$toast.error(`E-mail inválido: ${emailAddr}`)
            return
          }
        }

        if (this.tipoFormulario === 'salvar') {
          await this.salvarEmail(formData)
        } else {
          await this.atualizarEmail(formData)
        }

        this.limparCampos()
        this.fecharModal()

      } catch (e) {
        console.error('Erro ao processar e-mail:', e)
        this.$toast.error('Erro ao salvar e-mail')
      }
    },

    limparCampos () {
      this.email = {
        from: '',
        to: '',
        body: '',
        enfileirado: false
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
